import styled from 'styled-components'

const QuantityChartContainer = styled.div`
  width: 100%;

  h5.title {
    text-decoration: underline;
  }

  .summary {
    text-align: center;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;

    p.first {
      font-size: 1.2em;
      font-weight: bold;
    }

    &.chart {
      h2 {
        position: absolute;
        top: 46%;
        transform: translate(-50%, -50%);
        margin: 0;
        left: 50%;
      }
    }
  }

  .status {
    text-align: center;
  }
`

const PopoverContent = styled.div`
  width: 600px;
  padding: 20px;
`

export { PopoverContent, QuantityChartContainer }